module.exports = __webpack_public_path__ + "static/media/Military-Nurse_main_preview.05a68373.jpg";